import { styled } from '@sds-system/system';
import { theme } from '@sds-system/theme';
import {
  getBorderStyles,
  getColorStyles,
  getCSSStyles,
  getFlexStyles,
  getLayoutStyles,
  getOpacityStyles,
  getShadowStyles,
  getTypographyStyles,
  getZIndexStyles,
} from '@sds-system/utils';
import type { StyledDividerOptions } from './Divider.types';

export const StyledDivider = styled('div')<StyledDividerOptions>(
  ({ orientation, width, height, thickness }) => ({
    backgroundColor: theme.palette.gray[300],
    width: orientation === 'horizontal' ? width : `${thickness}px`,
    height: orientation === 'horizontal' ? `${thickness}px` : height,
    minWidth: orientation === 'horizontal' ? width : `${thickness}px`,
    minHeight: orientation === 'horizontal' ? `${thickness}px` : height,
  }),
  getLayoutStyles,
  getBorderStyles,
  getColorStyles,
  getOpacityStyles,
  getShadowStyles,
  getTypographyStyles,
  getFlexStyles,
  getZIndexStyles,
  getCSSStyles,
);
